import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const MembershipMappingView = angular
  .module('acme.view.application.membership.mapping', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.membership.mapping.controllers',
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const membershipMapping = {
      name: 'application.membership.mapping',
      url: '/mapping',
      views: {
        'subview-main': {
          controller: 'MembershipMappingController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/mapping/mapping.tpl.html',
        },
      },
      data: {
        pageTitle: 'External CRM Mapping',
        /** Secure With Permissions **/
        permissions: ['MEMBERSHIP_RE_MAPPING_VIEW'],
      },
    };

    $stateProvider.state(membershipMapping);
  }).name;
